import {React} from '@api'

export const stopPropagation = (e: KeyboardEvent | React.SyntheticEvent<any, Event>) =>
  e.stopPropagation()



// WEBPACK FOOTER //
// ./src/modules/whiteboard/components/stopPropagation.ts